import { IServiceSettings } from '../../../../assets/configuration';
import './css/footer.css';

export const Footer = (props: { serviceSettings: IServiceSettings }) => {
    return (
        <div className="footer">
            <div className="footer-title">
                Get the here & now Mobile App
            </div>

            <div className="footer-content">
                {/* Store buttons row */}
                <div className="store-button-group">
                    <a
                        href="https://apps.apple.com/us/app/here-now-local/id6752259355"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="store-image"
                            src={`${props.serviceSettings.hostUrl}/images/public/app-store.png`}
                            alt="Apple Store"
                        />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.vinformatix.herenowcommunity&pcampaignid=web_share"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="store-image"
                            src={`${props.serviceSettings.hostUrl}/images/public/google-play.png`}
                            alt="Google Play"
                        />
                    </a>
                </div>

                {/* Vinformatix logo row */}
                <div className="logo-single">
                    <a
                        href="https://www.vinformatix.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={`${props.serviceSettings.hostUrl}/images/vfx-logo.png`}
                            alt="Vinformatix Logo"
                        />
                    </a>
                </div>
            </div>

            <div className="footer-copyright">
                <em>Copyright &copy; {new Date().getFullYear()}. All rights reserved.</em>
            </div>
        </div>
    );
};
